import React, { HTMLAttributes } from 'react';
// import { FormControlTypeMap, Checkbox as MuiCheckbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { FormControlTypeMap } from '@mui/material/FormControl';
import MuiCheckbox from '@mui/material/Checkbox';
import { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FormControlLabelProps } from '@mui/material/FormControlLabel';

type ILabelControl = FormControlTypeMap<{}, 'label'>;

export type ICheckboxProps = {
    className?: string;
    value: boolean;
    onChange: CheckboxProps['onChange'];
    label?: FormControlLabelProps['label'];
    name: string;
    inputProps?: CheckboxProps['inputProps'] | { [key: string]: string };
} & HTMLAttributes<HTMLLabelElement> &
    ILabelControl['props'];
// &
//     IFormControl['props'];

// } & FormControlTypeMap<{}, 'div'>;
// } & OverridableComponent<FormControlTypeMap<{}, 'div'>>;

const Checkbox: React.FC<React.PropsWithChildren<ICheckboxProps>> = ({ className = '', value = false, required = false, onChange = () => { }, label = '', children, name, inputProps, ...rest }) => {
    return (
        <FormControlLabel
            control={<MuiCheckbox checked={value ? true : false} required={required} onChange={onChange} name={name} inputProps={inputProps} color="primary" />}
            label={label}
            {...rest}
        />
    );
};

export default Checkbox;
